import React from "react";
import "./servicePage.css";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import FeaturesOnServices from "./FeaturesOnServices";
import OurApproach from "./OurApproach";
import Technologies from "./Technologies";
import CallToAction from "./CallToAction";

const OnService = () => {
  return (
    <>
      <Particles title="On Service" />
      <HeroSection />
      <FeaturesOnServices />
      <OurApproach />
      <Technologies />
      <CallToAction />
    </>
  );
};

export default OnService;
